var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-button",class:[_vm.color,{width200:_vm.width200}],on:{"click":function($event){$event.stopPropagation();return _vm.onClick()}}},[_c('div',{staticClass:"thumbnail"},[_c('i',{class:_vm.icon})]),_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.textLabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }